/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowMusicNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowMusicNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Enjoy Music Together!",
    "Music Night Awaits!",
    "Jam Session for Everyone!",
  ],
  title: "Music Night",
  description: "Organize a fun music night.",
  longDescription:
    "Gather your friends for an exciting music night! Choose a date, decide on performances, and plan refreshments!",
  emoji: "🎶",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Music Night",
          emoji: "🎶",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the music night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on performances to enjoy?",
            description:
              "What performances should we focus on during the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What performances should we consider?",
                emoji: "🎤",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we plan for the night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Music Play!",
    outroDescription: "Your music night plans are set! Enjoy the performances!",
  },
};
